import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

import { ArchivioComponent } from './archivio/archivio.component';
import { ChatComponent } from './chat/chat.component';
import { NewsletterComponent } from './newsletter/newsletter.component';
import { AlertComponent } from './alert/alert.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { UsersComponent } from './users/users.component';
import { ComunicazioniComponent } from './comunicazioni/comunicazioni.component';
import { AssegnazionePresenzeComponent } from './assegnazione-presenze/assegnazione-presenze.component';
import { MappaComponent } from './mappa/mappa.component';
import { OrganizerComponent } from './organizer/organizer.component';
import { CalendarComponent } from './calendar/calendar.component';
import { SettingsComponent } from './settings/settings.component';
import { AppSettingsComponent } from './app-settings/app-settings.component';
import { RepositoryComponent } from './repository/repository.component';
import { BlogComponent } from './blog/blog.component';
import { RelatedBlogComponent } from './blog/related-blog/related-blog.component';
import { AppSignallerService } from './app-signaller.service';
import { CustomModule } from './custom/custom.module';

@NgModule({
  declarations: [
    AppComponent,
    ArchivioComponent,
    NewsletterComponent,
    ChatComponent,
    UsersComponent,
    AlertComponent,
    ComunicazioniComponent,
    AssegnazionePresenzeComponent,
    MappaComponent,
    OrganizerComponent,
    CalendarComponent,
    SettingsComponent,
    AppSettingsComponent,
    RepositoryComponent,
    BlogComponent,
    RelatedBlogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    CKEditorModule,
    CustomModule
  ],
  providers: [AppSignallerService],
  bootstrap: [AppComponent]
})
export class AppModule {
    window:any=<any>window;

    constructor(public signaller:AppSignallerService) {
        this.window.document.dispatchEvent(new CustomEvent('setTitle'));
        this.signaller.initService();
    }
}
